import { DataSyncSuccessDialog, fetchAuthConfigForDataSync } from './DataSync';
import { UnifiedAuthView } from './LowLevelUnifiedAuth';
import { DataSyncIntroScreen } from './DataSync';
import { UniversalAuthTracker } from './UsageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
export function DataSyncAuthModal({
  portalId,
  appId,
  accountId,
  onComplete,
  onCancel,
  onOpenExternalLink,
  onSetupSyncClick,
  onDoThisLaterClick,
  trackingSource,
  introScreen,
  successScreen
}) {
  const renderDefaultSuccessScreen = ({
    appName,
    authResponse
  }) => /*#__PURE__*/_jsx(DataSyncSuccessDialog, {
    appName: appName,
    onCancel: onCancel,
    portalId: portalId,
    appId: appId,
    authResponse: authResponse,
    onOpenExternalLink: onOpenExternalLink,
    onSetupSyncClick: onSetupSyncClick,
    onDoThisLaterClick: onDoThisLaterClick
  });
  return /*#__PURE__*/_jsx(UnifiedAuthView, {
    isModal: true,
    isReauth: !!accountId,
    portalId: portalId,
    onComplete: account => {
      UniversalAuthTracker.track('app-management', {
        applicationId: appId,
        source: trackingSource || 'unknown',
        action: accountId ? 'APP_RECONNECTED' : 'APP_CONNECTED'
      });
      onComplete(account);
    },
    onCancel: onCancel,
    introScreen: introScreen || DataSyncIntroScreen,
    fetchAuthConfig: fetchAuthConfigForDataSync(portalId, appId, accountId, undefined /* don't override the hublet */),
    successScreen: successScreen || renderDefaultSuccessScreen
  });
}
export default DataSyncAuthModal;